import { useTheme } from '@emotion/react'
import { Box } from '@mui/system'
import { ColDef } from 'ag-grid-community'
import { useState, useEffect, useCallback } from 'react'
import useCustomStyles from '../../../utils/hooks/CustomStylesHook'
import { ProrithmDevices, paginationOptions } from '../../ProRithm/Constants'
import { GetAllCompanies } from '../../../services/AdminService'
import MedAgDataGrid from '../../../components/MedAgDataGrid'

export const styles = () => ({
  proRithmDasboardContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
    padding: '2%',
    gap: 20,
  },
  proRithmDasboardTableContainer: {
    width: '100%',
    height: '100%',
  },
  proRithmDasboardheading: {
    color: '#090968',
    fontSize: '16px',
    fontWeight: 600,
  },
  proRithmDasboardCreateBtn: {
    textTransform: 'capitalize',
    backgroundColor: '#4682b4',
  },
  deviceText: {
    color: '#090968',
    fontSize: '16px',
    fontWeight: 600,
  },
  centerHeader: {
    color: '#ffffff',
    textAlign: 'center',
    '& .ag-header-cell-text': {
      flex: 1,
    },
  },
  lightBlue: {
    background: '#4682b4',
  },
})

const Company = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const [company, setCompany] = useState<ProrithmDevices[]>([])
  const columnDefs: ColDef[] = [
    {
      headerName: 'Thop id',
      field: 'id',
      sortable: false,
      filter: false,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Odoo id',
      field: 'odoo_id',
      sortable: false,
      filter: false,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Name',
      field: 'name',
      sortable: false,
      filter: false,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
  ]
  const fetchCompanies = useCallback(async () => {
    try {
      const response = await GetAllCompanies()
      setCompany(response?.data || [])
    } catch (error) {
      console?.error(error)
    }
  }, [])
  useEffect(() => {
    fetchCompanies()
  }, [fetchCompanies])

  return (
    <Box height={'93%'} width={'100%'}>
      <Box
        className={classes?.proRithmDasboardContainer}
        height={'100%'}
        width={'100%'}
      >
        <Box
          className={classes?.proRithmDasboardTableContainer}
          height={'100%'}
          width={'100%'}
        >
          <MedAgDataGrid
            tableHeading='Company'
            tableHeight={'100%'}
            rowData={company}
            columnDefs={columnDefs}
            pagination={false}
            pageSizeOptions={paginationOptions}
            headerHeight={30}
            searchFieldWidth={200}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default Company
